export const AUTH_RESET = 'AUTH_RESET';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';

export const AUTH_STORE = 'AUTH_STORE';
export const AUTH_CLEAN = 'AUTH_CLEAN';